module.exports = __webpack_public_path__ + "static/img/suspention.cf18a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/suspention.png
// module id = x+bR
// module chunks = 1